module.exports = __webpack_public_path__ + "static/media/cash_status.58aa5eb9.svg";